import { render } from "./VerifyEmail.vue?vue&type=template&id=dce691ea&scoped=true&ts=true"
import script from "./VerifyEmail.vue?vue&type=script&lang=ts"
export * from "./VerifyEmail.vue?vue&type=script&lang=ts"

import "./VerifyEmail.vue?vue&type=style&index=0&id=dce691ea&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dce691ea"]])

export default __exports__